// extracted by mini-css-extract-plugin
module.exports = {"container":"_1_6RZ-q","icon":"_1K-lFBR","primaryText":"_3TPVGyi","secondaryText":"_3EaiSVn"};